import React from "react";
import { Row, Col } from "react-bootstrap";

import PostCard from "../../components/PostCard";

// Pagination
// import { Box } from "../../components/Core";
// import { FaAngleRight, FaAngleLeft } from "react-icons/fa";
// import Pagination, { PageItem } from "../../components/Pagination";

const BlogList = ({ data }) => {
  return (
    <>
      {/* <!-- Blog section --> */}

      <Row>
        {data.map((item, index) => {
          const { slug } = item.fields;
          const { title, date, description, featuredimage } = item.frontmatter;
          const isHorizontal = (index + 1) % 3 === 0 || data.length === 1;
          return (
            <Col
              lg={isHorizontal ? "12" : "6"}
              className="mb-5"
              key={slug}
              style={{}}
            >
              <PostCard
                img={featuredimage}
                preTitle={date}
                title={title}
                link={slug}
                readMore
                horizontal={isHorizontal && true}
              >
                {description.substring(0, 120)}...
              </PostCard>
            </Col>
          );
        })}

        {/* <Col lg="12" className="mb-5">
          <PostCard
            horizontal
            img={imgB3}
            preTitle="Nov 14, 2020"
            title="How did we get 1M+ visitors in 30 days without anything!"
            readMore
          >
            Throwing consider dwelling bachelor joy her proposal laughter.
            Raptures returned disposed one entirely her men ham.
          </PostCard>
        </Col>
        <Col lg="6" className="mb-5">
          <PostCard
            img={imgB4}
            preTitle="Nov 14, 2020"
            title="How did we get 1M+ visitors in 30 days without anything!"
            readMore
          >
            Throwing consider dwelling bachelor joy her proposal laughter.
            Raptures returned disposed one entirely her men ham.
          </PostCard>
        </Col> */}
      </Row>
      {/* <Box className="d-flex justify-content-start" mt={4}>
      <Pagination>
        <PageItem>
          <FaAngleLeft />
        </PageItem>
        <PageItem>1</PageItem>
        <PageItem>2</PageItem>
        <PageItem>3</PageItem>
        <PageItem>...</PageItem>
        <PageItem>9</PageItem>
        <PageItem>
          <FaAngleRight />
        </PageItem>
      </Pagination>
    </Box> */}
    </>
  );
};

export default BlogList;
